<script>
  export let id = null,
    name = '',
    selected = '',
    options = [],
    borderColor = null,
    testid = null;
</script>

<style lang="scss">
  @import '../../styles/settings/core';
  @import '../../styles/settings/global';
  @import '../../styles/settings/colors';

  .select {
    border: solid 1px $grey-20;
    height: 4.8rem;
    width: 100%;
    margin-block-end: spacing(1);
    border-radius: 0.4rem;
    cursor: pointer;
    background-color: $white;
    padding: spacing(1);
    font: inherit;
    font-size: 16px;
    font-stretch: 100%;
    font-style: normal;
    font-weight: 400;
    letter-spacing: -0.2px;
    line-height: 24px;
    overflow-wrap: break-word;
    text-size-adjust: 100%;
    text-transform: none;
    word-break: keep-all;
    position: relative;
    -webkit-appearance: none;

    &:focus,
    &:active {
      outline: none;
    }
  }

  .borderColor-purple {
    border-color: $purple-50;
  }

  .borderColor-orange {
    border-color: $orange-50;
  }

  .select-container {
    position: relative;
  }

  .chevron {
    height: 1.6rem;
    position: absolute;
    right: 1.6rem;
    top: 1.6rem;
    pointer-events: none;
    z-index: 1; // Makes the chevron visible on white background

    :global([dir='rtl']) & {
      right: auto;
      left: 1.6rem;
    }
  }
</style>

<div class="select-container">
  <svg
    class="chevron"
    aria-label="Select container arrow. {id}"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 17 16"
  >
    <path
      fill="#000"
      fill-rule="evenodd"
      d="M13.678 5.69l-.516-.516a.313.313 0 0 0-.442 0L8.004 9.88 3.287 5.174a.313.313 0 0 0-.442
      0l-.516.516a.313.313 0 0 0 0 .443l5.453 5.453c.123.122.32.122.443 0l5.453-5.453a.313.313 0 0 0
      0-.443z"
    />
  </svg>
  <!-- svelte-ignore a11y-no-onchange -->
  <select
    on:change
    on:click
    bind:value={selected}
    {id}
    {name}
    class={`select${borderColor ? ` borderColor-${borderColor}` : ''}`}
    data-testid={testid}
  >
    {#each options as option}
      <option value={option.id}>
        {#if option.icon}{option.icon} &nbsp;{/if}
        {option.value}
      </option>
    {/each}
  </select>
</div>
